const _0 = "0px"
const _1 = "1px"
const _2 = "2px"
const _4 = "4px"
const _8 = "8px"
const _DEFAULT = "1px"
const config = { "0": _0, "1": _1, "2": _2, "4": _4, "8": _8, "DEFAULT": _DEFAULT,  }
export { config as default, _0, _1, _2, _4, _8, _DEFAULT }